import { dehydrate, QueryClient } from '@tanstack/react-query';
import type { GetStaticProps } from 'next';
import dynamic from 'next/dynamic';

import SecretomeC from 'src/containers/TerapiRegeneratif/Secretome';
import wrapper from 'src/redux';
import { actionGetFooterMenu, actionGetMenu } from 'src/redux/actions';

const HeadC = dynamic(() => import('src/components/Head'));

const Secretome = () => {
	return (
		<>
			<HeadC
				title="Mengenal Secretome di Indonesia, Terapi Kesehatan Terbaik"
				description={
					'Temukan manfaat secretome dalam terapi regeneratif. ' +
					'Pelajari bagaimana secretome dapat mempercepat penyembuhan, ' +
					'regenerasi sel, dan peremajaan kulit Kamu.'
				}
			/>
			<SecretomeC />
		</>
	);
};

export const getStaticProps: GetStaticProps = wrapper.getStaticProps((store) => async () => {
	const queryClient = new QueryClient();

	await store.dispatch(actionGetMenu());
	await store.dispatch(actionGetFooterMenu());

	return {
		props: {
			dehydratedState: dehydrate(queryClient),
			isDrawerOnly: true,
		},
	};
});

export default Secretome;
